import React from 'react';
import { Spinner, Modal, ModalBody, ModalFooter } from 'reactstrap';

const AutomationSavedModal = ({ isOpen, data, closeModal, message, t, onConfirm }) => {
    return (
        <Modal isOpen={isOpen} centered={true} size="lg">
            <ModalBody className="refillschema__modal refillschema__modal-request">
                {data.confirming && (
                    <div className="refillschema__modal-info refillschema__modal-info--warn">
                        <svg>
                            <use xlinkHref="#icon-help-circle"></use>
                        </svg>
                        <div>{t('refill:confirmDelete')}</div>
                    </div>
                )}
                {(data.saving || data.deleting) && (
                    <div className="refillschema__modal-spinner">
                        <Spinner />
                        <div>{t('refill:savingData')}...</div>
                    </div>
                )}
                {data.error && (
                    <div className="refillschema__modal-info refillschema__modal-info--warn">
                        <svg>
                            <use xlinkHref="#icon-error_outline"></use>
                        </svg>
                        <div>{t('refill:errorSavingData')}</div>
                    </div>
                )}
                {!data.error && (data.isSaved || data.isDeleted) && (
                    <div className="refillschema__modal-info refillschema__modal-info--success">
                        <svg>
                            <use xlinkHref="#icon-check-alt"></use>
                        </svg>
                        <div> {message ? message : t('main:dataSaved')}</div>
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                {(data.isSaved || data.error || data.isDeleted) && (
                    <div className="refillschema__modal-btn" onClick={() => closeModal()}>
                        {t('main:close')}
                    </div>
                )}
                {data.confirming && (
                    <>
                        <div className="refillschema__modal-btn" onClick={closeModal}>
                            {t('main:cancel')}
                        </div>
                        <div className="refillschema__modal-btn refillschema__modal-btn--confirm" onClick={onConfirm}>
                            {t('main:confirm')}
                        </div>
                    </>
                )}
            </ModalFooter>
        </Modal>
    );
};

export default AutomationSavedModal;
